import classNames from 'classnames';
import { observer } from 'mobx-react-lite';
import { FC } from 'react';

import { TextPlaceholder } from '@gem/components';
import { useTranslation } from '@gem/modules/i18n';
import { popupItemStyles } from '@gem/ui-kit';

import styles from './CallPermissionView.styles.m.css';

interface ICallPermissionViewProps {
  permissionLabel: string;
  permissionValue: string | null;
  onClick(): void;
}

export const CallPermissionView: FC<ICallPermissionViewProps> = observer(
  ({ permissionLabel, permissionValue, onClick }) => {
    const { t } = useTranslation();

    return (
      <div
        role="button"
        tabIndex={0}
        onClick={onClick}
        className={classNames(styles.container, popupItemStyles.interactive)}
      >
        {permissionValue ? (
          <>
            <div className={styles.label}>{t(permissionLabel)}</div>
            <div className={styles.value}>{t(permissionValue)}</div>
          </>
        ) : (
          <>
            <TextPlaceholder
              className={styles.gap}
              width={140}
            />
            <TextPlaceholder
              className={styles.gap}
              width={140}
            />
          </>
        )}
      </div>
    );
  }
);
